import { GlobalResponseObject } from "../../global-response-object";
import { SubCategoryWiseActAndBudgetRevenueDetails } from "./subCategoryWiseActAndBudgetRevenue-details";


export class SubCategoryWiseActAndBudgetRevenueResponse extends GlobalResponseObject{
data?:SubCategoryWiseActAndBudgetRevenueDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:SubCategoryWiseActAndBudgetRevenueDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}